import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-new-preset-dialog",
  templateUrl: "./new-preset-dialog.component.html",
  styleUrls: ["./new-preset-dialog.component.css"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatDialogActions,
    MatDialogClose
  ]
})
export class NewPresetDialogComponent {
  dialogRef = inject<MatDialogRef<NewPresetDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  newView(entityType: string) {
    this.dialogRef.close({
      entity: entityType
    });
  }
}
